import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  socket: any  = null;
  onlineUsers: any = [];
}



// WEBPACK FOOTER //
// ./src/app/services/globals.ts